<template>
  <div v-if="expert" class="w-100 h-100">
    <div class="bg-offwhite h-100 py-4 px-3 rounded-corners-10 shadow-sm">
      <a v-if="expert.slug" :href="`/${expertRouteSegment}/${expert.slug}`" class="h-100">
          <img class="mb-3 rounded partner-logo-shadow single-expert-image" :src="expert.avatarSquareLarge && expert.avatarSquareLarge.xx || defaultexpertLogo" :alt="expert.forename && expert.forename + ' ' + expert.surname || 'Experte'" />
          <h3 v-if="expert.forename || expert.surname" class="font-weight-bold m-0 pt-0 pt-md-3 text-dark font-size-mobile text-break h5">{{expert.forename}} {{expert.surname}}</h3>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: "singleExpertFeature",
  props: {
    settingsPerm: Object,
    expert: Object,
  },
  data() {
    return {
      defaultExpertLogo: '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/PlaceholderPERSONimageonpng.svg',
      expertRouteSegment: 'experten',
    };
  },
  setup() {},
  

  created() {
    if (this.settingsPerm?.isDevMioActive) {
      this.expertRouteSegment = 'experts';
    }else{
      this.expertRouteSegment = 'experten';
    }
  },

  methods: {
    
  },

};
</script>

<style scoped>
.single-expert-image{
    max-height: 150px;
    height: 150px;
    width: 150px;
    object-fit: cover;
}

  /* Small devices (landscape phones, 544px and up) */
  @media (max-width: 767px) {
    .font-size-mobile {
        font-size: 16px;
    }
  }
</style>
